<template>
	<div>
		<AppHeader
			title="마일리지 내역"
			is-history
			is-page-info
			@info-click="openModal('ModalMileage')"
		></AppHeader>
		<AppContent>
			<MileageDetail></MileageDetail>
		</AppContent>
		<AppFooter></AppFooter>

		<component v-if="modalComp" :is="modalComp" />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';

import MileageDetail from '@/components/MileageDetail';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		MileageDetail,
	},
	data() {
		return { modalComp: null };
	},
	methods: {
		openModal(compName) {
			if (!compName) return;

			this.modalComp = async () =>
				(await import(`@/components/${compName}.vue`)).default;
		},
	},
};
</script>
